module.exports = __webpack_public_path__ + "static/stCaths-9310cd964a9c44a6b24929161617d41b.jpg";